{
    "404": "404",
    "Oops":"OOPS!!",
    "pageNotFound": "The page doesn't exists or is unavailable.",
    "backHome": "Go Back to Home",
    "login": "Login"
  }
  